import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=1261e148&scoped=true"
import script from "./wechatBind.vue?vue&type=script&lang=ts"
export * from "./wechatBind.vue?vue&type=script&lang=ts"
import style0 from "./wechatBind.vue?vue&type=style&index=0&id=1261e148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1261e148",
  null
  
)

export default component.exports